import type { FC } from "react"

import Chip from "@/components/common/Chip/Chip"
import type { ApprovalStatus } from "@/graphql/codegen/graphql"
import {
  SOURCE_CHANGE_APPROVAL_STATUS_TO_CHIP_CLASS_NAME,
  SOURCE_CHANGE_APPROVAL_STATUS_TO_LABEL,
} from "@/screens/Products/components/SourceChanges/constants"

interface SourceChangeStatusChipProps {
  status: ApprovalStatus
  "data-testid"?: string
}

export const SourceChangeStatusChip: FC<SourceChangeStatusChipProps> = ({ status, "data-testid": testId }) => (
  <Chip
    size='small'
    className={`text-xs leading-[18px] ${SOURCE_CHANGE_APPROVAL_STATUS_TO_CHIP_CLASS_NAME[status]}`}
    label={SOURCE_CHANGE_APPROVAL_STATUS_TO_LABEL[status]}
    data-testid={testId}
  />
)
